import React from "react";
import { useTranslate } from "@refinedev/core";

import { Modal } from "@shared/components";
import { ConfigForm } from "../ConfigForm";
import { CreateConfigModalProps } from "./types";
import { useCreateConfigModal } from "./controller";

export const CreateConfigModal = React.memo(
  ({ modalRef, integrations, onComplete }: CreateConfigModalProps) => {
    const translate = useTranslate();
    const { methods, mutateAsync, isPending } = useCreateConfigModal(
      modalRef,
      integrations,
      onComplete
    );

    return (
      <Modal
        ref={modalRef}
        title={translate("v1/agreement_integration_config_admin.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <ConfigForm
          integrations={integrations}
          resetCredentialsOnIntegrationChange
        />
      </Modal>
    );
  }
);
